// Glider Configuration
const glider = new Glider(document.querySelector(".carousel-steps-lp-glider"), {
  slidesToShow: 1,
  slidesToScroll: 1,
  scrollLock: true,
  draggable: true,
  duration: 2,
  exactWidth: false,
  arrows: {
    prev: "#glider-prev",
    next: "#glider-next"
  },
  dots: ".carousel-steps-lp-dots",
})

function translateAriaCarouselHeader() {
  document.querySelector('.carousel-steps-lp #glider-prev')
    .setAttribute('aria-label', 'Anterior')
  document.querySelector('.carousel-steps-lp #glider-next')
    .setAttribute('aria-label', 'Próxima')

  document.querySelectorAll('.carousel-steps-lp-dots button.glider-dot').forEach(button => {
    button.setAttribute('aria-label', `Página ${button.getAttribute('data-index')}`)
  })
}

translateAriaCarouselHeader()